import React from 'react';

import { AppModule, MinimumPensionEstimatorModule } from '../modules';
const { ApplicationRouter } = AppModule.router;


const MinimumPensionEstimatorAppRouter = () => {
  return (
    <ApplicationRouter
      publicModules={[
        MinimumPensionEstimatorModule(),
      ]}
    />
  );
};

export default MinimumPensionEstimatorAppRouter;
